var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDialog',{attrs:{"label":"Post-qualification"},on:{"close":_vm.close},model:{value:(_vm.valueSync),callback:function ($$v) {_vm.valueSync=$$v},expression:"valueSync"}},[_c('PostQualificationCreateForm',{ref:"form",attrs:{"contactId":_vm.contactId,"caseId":_vm.caseId,"defaultEmail":_vm.defaultEmail},on:{"afterSubmit":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }